// One GA4 page_view per client-side route change (COM-1029).
//
// This site is a React SPA, so gtag('config') in index.html fires a page_view
// only for the initial HTML load. Without this component GA4 saw scroll,
// view_facility and click events for routes it had no page_view for, which is
// how the property ended up recording 0.71 page_views per session.
//
// ⚠️ Mount this AFTER <main> in the tree. React commits effects in tree order,
// so a tracker placed after the routes runs once the route's own <SEO /> has
// updated document.title — the page_view then carries the right title. Events
// fired from a page's mount effect still run first, which is why they go
// through afterPageView() rather than calling gtag directly.
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { firePageView } from '../lib/attribution';

const PageViewTracker: React.FC = () => {
  const { pathname } = useLocation();
  // The initial load's page_view comes from gtag('config'); sending another
  // here would double-count every landing.
  const initialLoad = useRef(true);

  useEffect(() => {
    if (initialLoad.current) {
      initialLoad.current = false;
      return;
    }
    firePageView(pathname);
  }, [pathname]);

  return null;
};

export default PageViewTracker;
